<template>
  <div
    data-bs-spy="scroll"
    data-bs-target="#list-example"
    data-bs-offset="0"
    class="scrollspy-example banCopy"
    tabindex="0"
  >
    <div class="transition introduce-box" id="group1">
      <h4 class="overview-title1 banCopy">集团介绍</h4>
      <div
        class="introduce-content col-lg-8 transition"
        v-html="overviewContent"
      ></div>
    </div>

    <div class="architecture-box" id="group2">
      <h4 class="overview-title">组织架构</h4>
      <a name="a2"></a>
      <img src="../image/组织架构图.png" class="col-12 col-lg-10" />
    </div>

    <div class="course-box col-12" id="group3">
      <h4 class="overview-title">发展历程</h4>
      <a name="a3"></a>
      <img
        src="../image/杭开发展历程.jpg"
      />
    </div>

    <div class="honor-box" id="group4">
      <h4 class="overview-title">集团荣誉</h4>
      <a name="a4"></a>
      <div
        class="
          overview-swiper-container
          swiper-container-initialized swiper-container-horizontal
          banCopy
          col-12 col-lg-8
        "
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide swiper-overview"
            v-for="(item, index) in honorImg"
            :key="index"
            data-swiper-slide-index="index"
          >
            <img
              class="col-12 col-lg-9 swiper-overview-img"
              :src="item.img_url"
              @click="clickModal(index)"
              data-bs-toggle="modal"
              data-bs-target="#myModal"
            />
          </div>
        </div>
      </div>

      <!-- 模态框 -->
      <div class="modal" id="myModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- 模态框头部 -->
            <div class="head-modal">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x"
                viewBox="0 0 16 16"
                data-bs-dismiss="modal"
                @click="clsUrl()"
              >
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                />
              </svg>
            </div>

            <!-- 模态框内容 -->
            <div class="modal-body">
                <img class="modal-img" :src="modalImgUrl">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-group fixed-left d-none d-lg-block transition">
      <a
        class="list-group-item transition hand"
        :class="{ active: isOverviewActive == 1 }"
        @click="jumpTarget($event)"
        >集团介绍</a
      >
      <a
        class="list-group-item transition hand"
        :class="{ active: isOverviewActive == 2 }"
        @click="jumpTarget($event)"
        >组织架构</a
      >
      <a
        class="list-group-item transition hand"
        :class="{ active: isOverviewActive == 3 }"
        @click="jumpTarget($event)"
        >发展历程</a
      >
      <a
        class="list-group-item transition hand"
        :class="{ active: isOverviewActive == 4 }"
        @click="jumpTarget($event)"
        >集团荣誉</a
      >
    </div>
  </div>
</template>

<script>
import "../swiper/swiper-bundle.min.css";
import Swiper from "../swiper/swiper-bundle.min.js";
import { isElementNotInViewport } from "../js/utils.js";
export default {
  data() {
    return {
      isOverviewActive: 1,
      scrollTop: 0,
      honorImg: [],
      overviewContent: "",
      modalImgUrl:'',
    };
  },
  mounted() {
    document.title="杭开集团-发展历程"

    this.Post();
    this.contentPost();
    var stop = false;
    // 监听滚动事件
    window.addEventListener("scroll", this.goScroll);
  },
  watch: {
    beforeDestroy() {
      window.removeEventListener("scroll", this.goScroll, true);
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.goScroll, true);
  },
  methods: {
    clsUrl(){
        this.modalImgUrl=" ";
    },
    clickModal(index) {
      console.log(1)
      //点击显示荣誉图片大图
      for(var i=0;i<this.honorImg.length;i++){
        if(index==i){
            this.modalImgUrl=this.honorImg[i]['img_url'];
            break;
        }
      }
    //   this.modalImgUrl='';
    //   this.modalImgUrl=url;
    },
    Swiper() {
      var comSwiper = new Swiper(".overview-swiper-container", {
        loop: true,
        speed: 3500,
        slidesPerView: "auto",
        spaceBetween: 30,
        slidesPerView: 5,
        centeredSlides: true,
        watchSlidesProgress: false,
        autoplay: {
          delay: 0,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: ".overview-swiper-button-next",
          prevEl: ".overview-swiper-button-prev",
        },
      });

      $(".overview-swiper-container").mouseover(function () {
        comSwiper.autoplay.stop();
      });
      $(".overview-swiper-container").mouseout(function () {
        comSwiper.autoplay.start();
      });
    },
    contentPost() {
      var url = "http://demoapi.hkjt.cn/pages/overview.php";

      this.axios.get(url).then((res) => {
        this.overviewContent = res.data[0]["content"];
      });
    },
    Post() {
      var url = "http://demoapi.hkjt.cn/pages/honor.php";

      this.axios.get(url).then((res) => {
        this.honorImg = res.data;
        //console.log(res.data)
        this.$nextTick(() => {
          this.Swiper();
        });
      });
    },
    goScroll() {
      if ($("#group1").length > 0) {
        if (
          document.getElementById("group1").getBoundingClientRect().top < 260 &&
          document.getElementById("group1").getBoundingClientRect().top +
            $("#group1").height() >
            300
        ) {
          this.isOverviewActive = 1;
        } else if (
          document.getElementById("group4").getBoundingClientRect().top < 380 &&
          document.getElementById("group4").getBoundingClientRect().top +
            $("#group4").height() >
            300
        ) {
          this.isOverviewActive = 4;
        } else if (
          document.getElementById("group2").getBoundingClientRect().top < 260 &&
          document.getElementById("group2").getBoundingClientRect().top +
            $("#group2").height() >
            300
        ) {
          this.isOverviewActive = 2;
        } else if (
          document.getElementById("group3").getBoundingClientRect().top < 260 &&
          document.getElementById("group3").getBoundingClientRect().top +
            $("#group3").height() >
            240
        ) {
          this.isOverviewActive = 3;
        }
      }
    },
    jumpTarget(e) {
      var string = e.currentTarget.innerHTML;
      switch (string) {
        case "集团介绍":
          $("html,body").animate(
            { scrollTop: $("#group1").offset().top - 200 },
            100
          );
          break;
        case "组织架构":
          $("html,body").animate(
            { scrollTop: $("#group2").offset().top - 200 },
            100
          );
          break;
        case "发展历程":
          $("html,body").animate(
            { scrollTop: $("#group3").offset().top - 200 },
            100
          );
          break;
        case "集团荣誉":
          $("html,body").animate(
            { scrollTop: $("#group4").offset().top - 200 },
            100
          );
          break;
      }
    },
  },
};
</script>

<style scoped>
.modal-dialog{
    max-width: 42rem !important;
}

.modal-img{
    width: 100%;
}

.head-modal{
    text-align: right;
    padding: 0.5rem 0.5rem 0 0;
    width: 100%;
}

.modal-body{
    width: 100%;
}

.honor-box {
  margin-bottom: 8rem;
}

.swiper-overview {
  width: 25%;
}

.swiper-wrapper{
  align-items: center;
}

.overview-swiper-container .swiper-wrapper {
  -webkit-transition-timing-function: linear;
  /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}

.overview-swiper-container {
  overflow: hidden;
  margin: 0 auto;
}

.swiper-overview-img {
  transition-duration: 0.2s;
}

.swiper-overview-img:hover {
  transform: scale(1.2);
  transition-duration: 0.2s;
}

.overview-title1 {
  display: block;
  width: 100vw;
  text-align: center;
  margin: 0 0 5rem 0;
  color: #363636;
}

.overview-title {
  display: block;
  width: 100vw;
  text-align: center;
  margin: 5rem 0 5rem 0;
  color: #363636;
}

.introduce-content {
  margin: 0 auto;
  text-indent: 2em;
  letter-spacing: 0.1rem;
  line-height: 2.5rem;
  font-family: "宋体";
  font-size: 1.2rem;
  color: #000;
  text-align: left;
}

.introduce-box {
  margin-top: 15rem;
  margin-bottom: 10rem;
}

.architecture-box {
  text-align: center;
}

.course-box {
  width: 100vw;
  overflow: hidden;
  margin-bottom: 5rem;
  overflow: hidden;
}

.course-box > img {
  width: 100%;
  margin: 0 auto;
}

@media screen and (max-width: 991px) {
  .course-box > img {
    margin-top: 7rem;
    transform: scale(1.2);
    transition-duration: 0.5s;
  }

  .introduce-box {
    margin-top: 6rem;
  }

  .overview-title1 {
    margin: 8rem 0 2rem 0;
  }
}

@media screen and (max-width: 540px) {
  .introduce-content {
    font-size: 0.9rem;
    line-height: 2rem;
    color: #252525;
    margin-left: 0.2rem;
  }

  .overview-title{
    margin: 3rem 0 2rem 0;
  }
}

@media screen and (max-width: 590px) {
  .architecture-box > img {
    /* transform: scale(1.25); */
  }
}
</style>